import {SPIELER_ACTION_SETTINGS} from "./spielerActionSettings";
import store from "../../../store/store";
import SPIELER_MEMBERSHIP_HANDLER from "../spieler/spielerMembershipHandler";
import TimeStamp from "../../timeStamp";

export default class SpielerActionIconList  {

    static getForSpieler(spieler, pendingActions, verein, lv){
        if ( spieler.search.passStatus === 'beantragt' ) {
            return  SpielerActionIconList.authCheck(spieler) ?
                [ SPIELER_ACTION_SETTINGS.editNew, SPIELER_ACTION_SETTINGS.foto, SPIELER_ACTION_SETTINGS.delete] : [];
        } else if ( spieler.search.passStatus === 'in Bearbeitung' ) {
            return store.state.user.permissions.pass ?
                [ SPIELER_ACTION_SETTINGS.resetNew, {msg: 'Pass wird gerade erstellt,<br>keine Änderungen möglich!'}] :
                [ {msg: 'Pass wird gerade erstellt,<br>keine Änderungen möglich!'}];
        } else {
            // ich bin abgemeldet === inaktiv => ich kann mich nur wiederanmelden für das laufende Sportjahr
                // wenn ich was anderes möchte => SPIELER löschen und neu anlegen!!!
            // ich habe heute eine gültige Membership => ich darf alles machen
                // wird meine heute gültige Membership angezeigt?
                    // ja => ändern erlaubt
                    // nein => ändern nicht erlaubt, Verweis auf gültige Membership
            // ich habe heute keine gültige Membership (und bin nicht abgemeldet === inaktiv => schon vorher geprüft)
                // wird meine letzte Membership angezeigt? (Kann auch in der ZUkunft liegen)
                    // ja => ändern vollumfänglich erlaubt
                    // nein => verweis auf letzte Membership, egal wo sie liegt
        // spieler inaktiv
            if ( spieler.status === 'inaktiv' ) {
                return SpielerActionIconList.checkForApplicableActions(spieler, pendingActions);
            } else {
        // spieler aktiv
                let currentMembership = SPIELER_MEMBERSHIP_HANDLER.getMainMembershipForToday(spieler.memberships);
                if ( currentMembership ) {
                    if ( currentMembership.lvVereinId === lv.id + '' + verein.id ) {
                        return SpielerActionIconList.checkForApplicableActions(spieler, pendingActions);
                    } else {
                        return [ {msg: "Das Mitglied ist aktuell in Verein '" + currentMembership.lvVereinId +
                            "' aktiv und kann nur dort geändert werden!"} ];
                    }
                } else {
                    let lastMembership = SPIELER_MEMBERSHIP_HANDLER.getLastRegularMembership(spieler.memberships);
                    if ( lastMembership.lvVereinId === lv.id + '' + verein.id ) {
                        return SpielerActionIconList.checkForApplicableActions(spieler, pendingActions);
                    } else {
                        return [ {msg: "Der Spieler war zuletzt in Verein '" + lastMembership.lvVereinId +
                            "' aktiv und kann nur dort geändert werden!"} ];
                    }
                }
            }
        }
    }

    static checkForApplicableActions(spieler, pendingActions){
        let availableActions = [
            'wiederanmeldung',
            'edit',
            'ummeldung',
            'leihe',
            'abmeldung',
            'passDuplikat',
            'bestaetigungen',
            'verlaengerung',
            'foto',
            'loeschen',
            'drucken',
        ];
        let actions = [];
        //let anyPending = SpielerActionIconList.anyPending(spieler, pendingActions)
        pendingActions = pendingActions
                            .filter(action => action.search_spieler === spieler.id );
        availableActions.forEach( (action) => {
            let actionObject = SpielerActionIconList[action](spieler, pendingActions);
            if ( actionObject ) { actions.push(actionObject) }
        });
        return JSON.parse(JSON.stringify(actions)) ;
    }

    static edit(spieler){
        let item = null;
        if ( spieler.status === 'aktiv' && SpielerActionIconList.authCheck(spieler) ) {
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.edit));
        }
        return item;
    }

    static ummeldung(spieler, pendingActions){
        let item = null;
        let month = parseInt(TimeStamp.getTodayString().split('-')[1]);
        if ( month !== 12 && month !== 1 && (
                store.state.user.permissions.pass ||
                spieler.local && parseInt(spieler.local.lvId) < 20 && store.state.user.permissions.classic ||
                spieler.local && parseInt(spieler.local.lvId) > 20 && store.state.user.permissions.bowling ||
                !( spieler.local && spieler.local.lvId )
            )
        ) {
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.ummeldung));
            item.pending = SpielerActionIconList.getPendingForAction(spieler, pendingActions, 'ummeldung');
        }
        return item;
    }

    static leihe(spieler, pendingActions){
        let item = null;
        let month = parseInt(TimeStamp.getTodayString().split('-')[1]);
        if ( (month === 12 || month === 1) && spieler.status !== 'inaktiv' && (
                store.state.user.permissions.pass ||
                spieler.local && parseInt(spieler.local.lvId) < 20 && store.state.user.permissions.classic ||
                spieler.local && parseInt(spieler.local.lvId) > 20 && store.state.user.permissions.bowling ||
                !( spieler.local && spieler.local.lvId )
            )
        ) {
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.leihe));
            item.pending = SpielerActionIconList.getPendingForAction(spieler, pendingActions, 'leihe');
        }
        return item;
    }

    static abmeldung(spieler, pendingActions){
        let item = null;
        if ( spieler.status === 'aktiv' && SpielerActionIconList.authCheck(spieler) ) {
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.abmeldung)) ;
            item.pending =  SpielerActionIconList.getPendingForAction(spieler, pendingActions, 'abmeldung');
        }
        return item;
    }

    static verlaengerung(spieler, pendingActions){//
        let item = null;
        if ( spieler.status === 'aktiv' && SpielerActionIconList.authCheck(spieler) ) {
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.verlaengerung));
            item.pending = SpielerActionIconList.getPendingForAction(spieler, pendingActions, 'verlaengerung');
            //item.color = SpielerActionIconList.getVerlaengerungStatus(spieler, sportJahr);
            item.color = store.state.local.sportJahr.getVerlaengerungStatus(spieler)
        }
        if ( item && !item.pending && !item.color ) { item = null; }
        return item;
    }

    static bestaetigungen(spieler){ //spieler, pendingActions
        let item = null;
        //if ( /*spieler.status === 'aktiv' &&*/
        //   !SpielerActionIconList.getPendingForAction(spieler, pendingActions, 'abmeldung') ) {

            //item.color = SpielerActionIconList.getBestaetigungenStatus(spieler);
        //}
        if ( SpielerActionIconList.authCheck(spieler) ) {
            //console.log ("SPIELER SPORTART", spieler.sportart);
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.bestaetigungen)) ;
            /*item.color = !spieler.attest || !spieler.ade || !spieler.dsv ? 'error' : '';
            if ( item.color !== 'error' ) {
                let ageOfAttest = TimeStamp.getDiffInFullYears(spieler.attest);
                if ( ageOfAttest >= 2  ) { item.color = 'error' }
                console.log ("ageOfAttest", spieler.attest, ageOfAttest);
                // offen: ALTERSABFRAGE U14, U16, U18
            }*/
        }
        return item;
    }

    static wiederanmeldung(spieler, pendingActions){
        let item = null;
        if ( spieler.status === 'inaktiv' && SpielerActionIconList.authCheck(spieler) ) {
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.wiederanmeldung)) ;
            item.pending = SpielerActionIconList.getPendingForAction(spieler, pendingActions, 'wiederanmeldung');
        }
        return item;
    }

    static passDuplikat(spieler, pendingActions){
        let item = null;
        if ( spieler.status === 'aktiv' && SpielerActionIconList.authCheck(spieler) ) {
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.passDuplikat));
            item.pending = SpielerActionIconList.getPendingForAction(spieler, pendingActions, 'passDuplikat');
        }
        return item;
    }

    static loeschen(){
        let item = null;
        if ( store.state.user.permissions.pass ) {
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.loeschen));
        }
        return item;
    }

    static drucken(){
        let item = null;
        if ( store.state.user.permissions.pass ) {
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.drucken));
        }
        return item;
    }

    static foto(spieler){
        let item = null;
        if ( SpielerActionIconList.authCheck(spieler) ) {
            item = JSON.parse(JSON.stringify(SPIELER_ACTION_SETTINGS.foto));
        }
        return item;
    }

// common methods
    static getPendingForAction (spieler, pendingActions, actionType) {
        return pendingActions.filter( action =>
                        action.actionType === actionType
                        &&
                        spieler.id === action.search_spieler
        )[0];//.length > 0;
    }

    static authCheck(spieler){
        if ( spieler.local && spieler.local.lvId ) {
            const lvKey = 'lv' + spieler.local.lvId;
            return store.state.user.permissions[lvKey] || store.state.user.permissions.pass;
        } else {
            return true;
        }
    }

    /*static anyPending(spieler, pendingActions){
        return pendingActions.filter( action =>
            (   action.actionType === 'abmeldung' ||
                action.actionType === 'verlaengerung' ||
                action.actionType === 'wiederanmeldung' ||
                action.actionType === 'ummeldung'
            )
            &&
            spieler.id === action.status_spieler
        ).length > 1;
    }*/
    /*static getVerlaengerungStatus(spieler, sportJahr) {
        const today = TimeStamp.getTodayString();
        const todayMonth = parseInt(today.split('-')[1]);
        const currentSportJahrUntil = store.state.local.sportJahr.current.until;
        const verlaengerungStatus = store.state.local.sportJahr.getVerlaengerungStatus(spieler.dates.lastSportTag);
        if (  ) {

        }

        console.log ("getVerlaengerungStatus spieler:", spieler);
        let color = '';
        if ( spieler.dates.lastSportTag < sportJahr.until ) {
            color = 'error';
        } else if ( spieler.dates.lastSportTag === sportJahr.until) {
            color = 'warning'
        }
        return color;
    }*/
    /*static getVerlaengerungStatus(validityDate, maxYears) {
        maxYears = maxYears ? maxYears : 2;
    // date to check
        let playerDateParts = validityDate.split('-');
        let validFromYear = parseInt(playerDateParts[0]);
        let validFromMonth = parseInt(playerDateParts[1]);
    // today
        let today = TimeStamp.getGMTTimestamp();
        let todayDateParts = TimeStamp.getLocalDate(today).split('-');
        let todayYear = parseInt(todayDateParts[0]);
        let todayMonth =  parseInt(todayDateParts[1]);
    // delta
        let yearDelta = todayYear - validFromYear;
        let color = '';
    // check delta
        if ( yearDelta > maxYears ) {
            color = 'error';
        } else if ( yearDelta === maxYears ) {
            if ( validFromMonth < 7 || todayMonth > 6 ) {
                color = 'error';
            } else if (todayMonth >= 4) {
                color = 'warning';
            }
        }
        return color;

    }*/
    /*static getBestaetigungenStatus(spieler) {
        let checkFields = [{field: 'ade', years: 2},{field: 'dsv', years: 2},{field: 'attest', years: 2}];
        let color = '';
        for ( let i = 0; i < checkFields.length; i++ ) {
            let fieldName = checkFields[i].field;
            let colorTemp = SpielerActionIconList.getVerlaengerungStatus(spieler[fieldName], checkFields[i].years);
            if ( colorTemp !== '' ) { color = colorTemp }
            if ( color === 'error' ) { break; }
        }
        return color;
    }*/
}